import React from "react";
import RaisedButton from "material-ui/RaisedButton";
import "../App.css";

export class Next extends React.Component {
  render() {
    return (
      <div className="Bottom">

        <RaisedButton
          backgroundColor="#008fd5"
          labelColor="#FFFFFF"
          label="Next"
          onTouchTap={e => this.props.onNext(e)}
        >
          {" "}
        </RaisedButton>
        <br />
        <br />
        <br />
      </div>
    );
  }
}

export class Submit extends React.Component {
  render() {
    return (
      <div className="Bottom">

        <RaisedButton
          style={{ marginRight: 12 }}
          backgroundColor="#008fd5"
          labelColor="#FFFFFF"
          label="Submit"
          onTouchTap={e => this.props.onSubmit(e)}
        />
        {" "}{" "}{" "}
        <RaisedButton
          className="Skip"
          labelColor="#FFFFFF"
          backgroundColor="#aaa"
          label="Skip"
          onTouchTap={() => this.props.onSkip()}
        />
        <br />

        <br />
        <br />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SubmitAndCheckbox.js